import React, { Component } from "react";
import axios from "axios";

import domain from "./domain";
// import {Link} from 'react-router-dom';
// import {Button} from 'mdbreact'
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import { Row, Col, CardBody } from "mdbreact";
function indexN(cell, row, enumObject, index) {
  return <div>{index + 1}</div>;
}

function capitalize(str) {
  var splitStr = str.toLowerCase().split(' ');
  for (var i = 0; i < splitStr.length; i++) {
      // You do not need to check if i is larger than splitStr length, as your for does that for you
      // Assign it back to the array
      splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);     
  }
  // Directly return the joined string
  return splitStr.join(' '); 
}
// const capitalize = (s) => {
//   if (typeof s !== "string") return "";
//   return s.charAt(0).toUpperCase() + s.slice(1).toLowerCase();
// };
class TraineeDetailsById extends Component {
  constructor() {
    super();
    this.state = {
      participants: [],
      status: "",
      course_name: null,
    };
  }

  componentDidMount() {
    this.getParticipants();
    this.getCourse();
  }
  //   editButtonFormatter=(row)=>{
  //     return ((this.state.status==='Completed')?<Link className="btn blue disabled" to="#">EDIT</Link>:<Link className="btn blue" to={`/edit-participant/${row}`}>EDIT</Link>)

  //   }
  //   deleteButtonFormatter=(row)=>{
  //     return ((this.state.status==='Completed')?<Button name="delete" value={row} disabled>DELETE</Button>:<Button name="delete" value={row} onClick={this.onDelete.bind(this)} >DELETE</Button>)

  //   }

  // onDelete=(e)=>{
  //   e.preventDefault();
  //   console.log(e.target.value)
  //  let r=window.confirm('Do you want to delete the Trainee Details')
  //   if(r)
  //   {

  //   axios.delete(`${domain.DBServer}/delete-participant/${e.target.value}`)
  //     .then(response => {
  //       console.log(response.data)
  //       if(response.data===1)
  //       {

  //         alert('Trainee details deleted Successfully')
  //         window.location.reload();

  //       }

  //     }).catch(err => console.log(err));
  //   }
  //   else
  //     return true;
  // }

  async getCourse() {
    let courseId = this.props.match.params.id;
    let result = await axios.get(`${domain.DBServer}/fetch-course/${courseId}`);
    console.log(result.data[0]);
    this.setState({
      status: result.data[0].status,
      course_name: result.data[0].title,
    });
  }

  getParticipants() {
    let courseId = this.props.match.params.id;
    axios
      .get(`${domain.DBServer}/fetch-trainees/${courseId}`)
      .then((response) => {
        let data = response.data;
        let ress = data.map((item) => {
          return {
            name: capitalize(item.name),
            designation: capitalize(item.designation),
            organization: capitalize(item.organization),
            city: capitalize(item.city),
            t_state: capitalize(item.t_state),
          };
        });
        this.setState({ participants: ress }, () => {
          //console.log(this.state);
        });
      })
      .catch((err) => console.log(err));
  }

  render() {
    console.log(this.state);
    let coursetable;
    if (this.state.participants != null) {
      coursetable = (
        <BootstrapTable
          data={this.state.participants}
          striped
          hover
          version="4"
          condensed
          // selectRow={selectRowProp}

          search
          // tableStyle={ { border: '#0000FF 2.5px solid' } }
          // containerStyle={ { border: '#FFBB73 2.5px solid' } }
          headerStyle={{ border: "red 1px solid" }}
          bodyStyle={{ border: "green 1px solid" }}
          keyField="trainee_id"
        >
          <TableHeaderColumn
            width="50px"
            dataFormat={indexN}
            dataAlign="right"
            export={false}
          >
            S. No
          </TableHeaderColumn>
          {/* <TableHeaderColumn dataField='trainee_id'  dataSort width='100px'>Trianee ID</TableHeaderColumn> */}
          <TableHeaderColumn
            dataField="name"
            dataSort
            filter={{ type: "TextFilter" }}
          >
            Name
          </TableHeaderColumn>
          <TableHeaderColumn
            dataField="designation"
            dataSort
            filter={{ type: "TextFilter" }}
          >
            Designation
          </TableHeaderColumn>
          <TableHeaderColumn
            dataField="organization"
            dataSort
            filter={{ type: "TextFilter" }}
          >
            Organisation
          </TableHeaderColumn>
          {/* <TableHeaderColumn dataField='address' dataSort filter={ { type: 'TextFilter' } }>Address</TableHeaderColumn> */}
          <TableHeaderColumn
            dataField="city"
            dataSort
            filter={{ type: "TextFilter" }}
          >
            City
          </TableHeaderColumn>
          <TableHeaderColumn
            dataField="t_state"
            dataSort
            filter={{ type: "TextFilter" }}
          >
            State
          </TableHeaderColumn>
          {/* <TableHeaderColumn dataField='gender' dataSort filter={ { type: 'TextFilter' } }>Gender</TableHeaderColumn>
         {/* <TableHeaderColumn dataField='mobile' dataSort filter={ { type: 'TextFilter' } }>Mobile</TableHeaderColumn> */}
          {/* <TableHeaderColumn dataField='email' dataSort filter={ { type: 'TextFilter' } }>Email</TableHeaderColumn>  */}
          {/* <TableHeaderColumn dataField="trainee_id" dataFormat={this.editButtonFormatter} disabled export={false}>Edit</TableHeaderColumn>

          <TableHeaderColumn dataField="trainee_id" dataFormat={this.deleteButtonFormatter} disabled export={false}>Delete</TableHeaderColumn>
 */}

          {/*  */}
        </BootstrapTable>
      );
    }

    return (
      <div>
        <Row>
          <Col md="12">
            <CardBody>
              {/* <Link className="btn grey" to="/Home">Back</Link> */}
              <h1 style={{ textAlign: "center", color: "blue" }}>
                Trainee Details of {this.state.course_name}
              </h1>
              {coursetable}
            </CardBody>
          </Col>
        </Row>
      </div>
    );
  }
}

export default TraineeDetailsById;
